/** Canonical user-facing product name (no trailing "s"). */
export const SITE_NAME = "MediBrick";

/** Show Blog link in site footer. Set false to hide until content exists. */
export const FOOTER_SHOW_BLOG = false;
